<script setup lang="ts">
import { useLayoutStore } from '@/Stores/layoutStore';
import { computed } from 'vue';

const store = useLayoutStore();
const isFocused = computed(() => store.isFocused);

const props = withDefaults(
    defineProps<{
        title: string;
        subtitle: string;
        description: string;
        image?: string;
        moduleClass?: string;
        roundedClass?: string;
    }>(),
    {
        moduleClass: 'col-span-1 lg:col-span-3',
    },
);

const computedClass = computed(() => [isFocused.value ? 'order-first' : 'order-first lg:order-0', props.moduleClass].filter(Boolean).join(' '));
</script>

<template>
    <div class="flex p-px" :class="computedClass">
        <div class="w-full overflow-hidden rounded-lg bg-gray-800 ring-1 ring-white/15">
            <div>
                <img v-if="image" :src="image" alt="" />
                <div class="p-10">
                    <h3 v-if="title" class="text-sm/4 font-semibold text-gray-400">{{ title }}</h3>
                    <p class="mt-2 text-lg font-medium tracking-tight text-white">{{ subtitle }}</p>
                    <p class="mt-2 max-w-lg text-sm/6 text-gray-400">{{ description }}</p>
                </div>
            </div>
            <div class="w-full">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
